class GlobalNewsletterSignup extends HTMLElement {
  constructor() {
    super();

    this.container = this.querySelector('.global-newsletter-signup__container');
    this.trigger = this.querySelector('.global-newsletter-signup__trigger');
  }

  connectedCallback() {
    this.trigger.addEventListener('click', () => this.handleClick());
    console.log("GLOBAL NEWSLETTER SIGNUP - CONNECTED");
  }
  disconnectedCallback() {
    this.trigger.removeEventListener('click', () => this.handleClick());
    console.log("GLOBAL NEWSLETTER SIGNUP - DISCONNECTED");
  }

  handleClick = (e) => {
    console.log("GLOBAL NEWSLETTER SIGNUP - CLICKED");
    this.container.dataset.open = this.container.dataset.open === 'true' ? 'false' : 'true';
  }

}
customElements.get('global-newsletter-signup') || customElements.define('global-newsletter-signup', GlobalNewsletterSignup);